import * as React from "react";
import ImageView from "../../components/SmartImage";
import { formatAspect } from "../../utils/banner";
import { BannerContainerBox } from "./styles";
export const BannerContainer = (props) => {
    const { banner, className = "", style = {}, keepSize, imgClassName = "", placeholderBg, gridHeight, gridWidth, } = props;
    let width = formatAspect(props.width || +(banner.width || 0));
    let qnParams = props.qnParams;
    if (width) {
        qnParams = Object.assign(Object.assign({}, qnParams), { w: width });
    }
    return (React.createElement(BannerContainerBox, { "data-id": props.id, className: className, style: Object.assign(Object.assign({}, style), { backgroundRepeat: "no-repeat" }), id: props.id, width: gridWidth, height: gridHeight },
        React.createElement(ImageView, { src: banner.img, online: true, imgClass: imgClassName, qnParams: qnParams, keepSize: keepSize, placeholder: placeholderBg, fallbackSrc: placeholderBg }),
        props.children));
};
